import * as React from 'react'
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl'
import Button from '../../../../components/button'
import styles from './hero.module.scss'

export default function Start() {
  return (
    <div className={styles.root}>
      <div className={styles.outer}>
        <div className={styles.fade}>
          <div className={styles.inner}>
            <h1 className={styles.heading}>
              <FormattedMessage defaultMessage="Vi moderniserar bokföringssverige." id="about.hero.heading" />
            </h1>
            <p className={styles.lede}>
              <span>
                <FormattedHTMLMessage
                  defaultMessage="Vi skapar supersmidiga <span class='hidden-xs'>bokförings-<br />tjänster</span><span class='visible-xs'>bokföringstjänster</span>, ny typ av realtidsrådgivning och&nbsp;intelligenta företagslösningar. Företagande ska vara enkelt, roligt och&nbsp;lönsamt&nbsp;för&nbsp;dig."
                  id="about.hero.lede"
                />
              </span>
            </p>
            <Button className={styles.button} href="/#signup">
              <span className="visible-xs">
                <FormattedMessage defaultMessage="Upptäck vår kompletta bokföringstjänst" id="about.hero.cta" />
              </span>
              <span className="hidden-xs">
                <FormattedMessage
                  defaultMessage="Läs mer om vårt kompletta bokföringssystem"
                  id="about.hero.cta-short"
                />
              </span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
